import { type ModulFromThemaRouter } from '../dtos';

export type LeistungstemplateFromModul = NonNullable<
  NonNullable<ModulFromThemaRouter['teilleistungstemplates']>[number]
>['leistungstemplate'];

type ModulWithTeilleistungstemplates = {
  teilleistungstemplates?: ModulFromThemaRouter['teilleistungstemplates'] | null;
};

export function getLeistungstemplatesFromModul(modul: ModulWithTeilleistungstemplates): LeistungstemplateFromModul[] {
  return (modul.teilleistungstemplates ?? [])
    .map((teilleistungstemplate) => teilleistungstemplate.leistungstemplate)
    .toSorted((a, b) => a.index - b.index);
}
